import React from "react";
import PropTypes from "prop-types";
import TextEditor from "../TextEditor"; // Assuming TextEditor is in the same directory
import Screens from "../user/Screens"; // Assuming Screens is in the same directory
import translations from "../../translation"; // Assuming translations is in the specified path

const EditorModal = ({
  isOpen,
  onClose,
  content,
  setContent,
  attachment,
  setAttachment,
  title,
  name,
  id, // Add id as a prop to identify the item being updated
  language, // Language prop for translations
}) => {
  if (!isOpen) return null;

  const translate = (key) => translations[language][key] || key; // Translation function

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const formData = new FormData();
      formData.append("id", id); // Add id to the request
      formData.append("content", content); // Add content to the request
      formData.append("sender_id", user.id); // Include sender ID if required

      if (attachment) {
        formData.append("attachment", attachment); // Optional: Add attachment if it exists
      }

      const response = await fetch(
        `${process.env.REACT_APP_CHECK_USER_API}/api/user/announcement/update`, // Replace with your API endpoint
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update content.");
      }

      const data = await response.json();
      alert(translate("contentUpdatedSuccessfully"));
      onClose(); // Close the modal after successful submission
    } catch (error) {
      console.error("Error updating content:", error);
      alert(translate("errorUpdatingContent"));
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-[95%] max-h-[95vh] shadow-lg rounded-lg p-6 overflow-auto relative">
        {/* Modal Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold">{translate("editContent")}</h2>
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-white bg-red-500 hover:bg-red-400 rounded-lg font-medium"
          >
            {translate("close")}
          </button>
        </div>

        {/* Modal Body */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Text Editor Section */}
          <form onSubmit={handleFormSubmit} className="flex flex-col h-full">
            <div className="my-3 flex-grow">
              <TextEditor
                setContent={setContent}
                setAttachment={setAttachment}
                initialValue={content}
                language={language}
              />
            </div>
            <div className="d-flex justify-content-end mt-4">
              <button type="reset" className="btn btn-outline-danger me-3">
                {translate("reset")}
              </button>
              <button type="submit" className="btn btn-success">
                {translate("updateContent")}
              </button>
            </div>
          </form>

          {/* Screens Section */}
          <div className="bg-gray-50 p-4 rounded-lg shadow-md overflow-auto">
            <Screens content={content} title={title} name={name} language={language}/>
          </div>
        </div>
      </div>
    </div>
  );
};

EditorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  content: PropTypes.string,
  setContent: PropTypes.func.isRequired,
  attachment: PropTypes.object,
  setAttachment: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired, // Add id as a required prop
  language: PropTypes.string.isRequired, // Add language prop for translations
};

export default EditorModal;
